import { useEffect, useState } from 'react';
import { Dimensions } from '@99designs/browser';
import {
    getAvailableZoomLevels,
    getNextZoomLevel,
    getPrevZoomLevel,
    getZoomLevel,
} from './zoomHelpers';
import { ZoomLevel } from './zoomLevel';

function useZoom(viewSize: Dimensions, fileDimensions: Dimensions, fileId: string) {
    const initialZoomLevel = ZoomLevel.FIT_TO_CONTAINER;
    const [zoomLevel, setZoomLevel] = useState(initialZoomLevel);
    const [availableZoomLevels, setAvailableZoomLevels] = useState<ZoomLevel[]>([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => setZoomState(), [viewSize, fileId]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => setZoomLevel(initialZoomLevel), [fileId]);

    const setZoomState = () => {
        const availableZoomLevels = getAvailableZoomLevels(fileDimensions, viewSize);
        const newZoomLevel = getZoomLevel(zoomLevel, availableZoomLevels);

        setZoomLevel(newZoomLevel);
        setAvailableZoomLevels(availableZoomLevels);
    };

    const zoomOut = () => {
        const level = getPrevZoomLevel(availableZoomLevels, zoomLevel);
        if (level) {
            setZoomLevel(level);
        }
    };

    const zoomIn = () => {
        const level = getNextZoomLevel(availableZoomLevels, zoomLevel);
        if (level) {
            setZoomLevel(level);
        }
    };

    const canZoomIn = Boolean(getNextZoomLevel(availableZoomLevels, zoomLevel));

    const canZoomOut = Boolean(getPrevZoomLevel(availableZoomLevels, zoomLevel));

    return {
        zoomLevel,
        zoomIn,
        zoomOut,
        canZoomIn,
        canZoomOut,
    };
}

export default useZoom;
